export default {
  plugins: []
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/plugin_manager/config/config.js